import global from '@/config/global_config'
// import api from '@/api';

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

const tools={
    success(obj,msg) {
        obj.$message({
        message: msg,
        type: 'success'
        });
    },
    error(obj,msg) {
        obj.$message({
            message: msg,
            type: 'error'
        });
    },
    Dlog(obj){
        if(global.isDebug)console.log(obj);
    },
    trim(str){ 
        return str.replace(/(^\s*)|(\s*$)/g, ""); 
    },
    containsInArray(value,arr) {  
        for(var i = 0; i < arr.length; i++){
            if(value === arr[i]){
                return true;
            }
        }
        return false;
    },
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
  formatDate: {
    format: function (date, pattern) {
        pattern = pattern || DEFAULT_PATTERN;
        return pattern.replace(SIGN_REGEXP, function ($0) {
            switch ($0.charAt(0)) {
                case 'y': return padding(date.getFullYear(), $0.length);
                case 'M': return padding(date.getMonth() + 1, $0.length);
                case 'd': return padding(date.getDate(), $0.length);
                case 'w': return date.getDay() + 1;
                case 'h': return padding(date.getHours(), $0.length);
                case 'm': return padding(date.getMinutes(), $0.length);
                case 's': return padding(date.getSeconds(), $0.length);
            }
        });
    },
    parse: function (dateString, pattern) {
        var matchs1 = pattern.match(SIGN_REGEXP);
        var matchs2 = dateString.match(/(\d)+/g);
        if (matchs1.length == matchs2.length) {
            var _date = new Date(1970, 0, 1);
            for (var i = 0; i < matchs1.length; i++) {
                var _int = parseInt(matchs2[i]);
                var sign = matchs1[i];
                switch (sign.charAt(0)) {
                    case 'y': _date.setFullYear(_int); break;
                    case 'M': _date.setMonth(_int - 1); break;
                    case 'd': _date.setDate(_int); break;
                    case 'h': _date.setHours(_int); break;
                    case 'm': _date.setMinutes(_int); break;
                    case 's': _date.setSeconds(_int); break;
                }
            }
            return _date;
        }
        return null;
    }
  },
  getCurrentYear:function(){
    var now = new Date();
    return now.getFullYear();
  },
  getCurrentMonth:function(){
    var now = new Date();
    var month = now.getMonth()+1;
    if(month <10 )month = "0"+month;
    return month;
  },
  getCurrentDate:function(){
    var now = new Date();
    var date = now.getDate()
    if(date <10 )date = "0"+date;
    return date;
  },
  getYesterday:function(){
    var now = new Date();
    var date = now.getDate()-1
    if(date <10 )date = "0"+date;
    return date;
  },
  // 秒转换分钟00:00:00格式
  timeToMinute:function (times) {
    var result = '';
    var hour,minute,second
    if (times > 0) {
      hour = Math.floor(times / 3600);
      if (hour < 10) {
        // hour = "0"+hour;
      }
      minute = Math.floor((times - 3600 * hour) / 60);
      if (minute < 10) {
        // minute = "0"+minute;
      }
      second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
      if (second < 10) {
        // second = "0"+second;
      }
      if(hour == 0){
          if(minute != 0){
            result = minute+'m';
            if(second != 0){
                result = result+second+'s';
            }
          }
          else{
            if(second != 0){
                result = result+second+'s';
            } 
          }
      }
      else{
        result = hour+'h';
        if(minute != 0){
            result = result + minute+'m';
            if(second != 0){
                result = result+second+'s';
            }
        }
        else{
            if(second != 0){
                result = result+second+'s';
            } 
          }
      }
    return result;
    }
 },
 //判断字符是否为空的方法
 strIsEmpty:function (obj) {
  if(typeof obj == 'number'){
    return false;
  }
    if(typeof obj == "undefined" || obj == null || obj == ""){
        return true;
    }else{
        return false;
    }
  },

//判断字符是否为空的方法
 strIsEmptyV2:function (obj) {
  // if(obj == 0 || obj == '0'){
  //   return false;
  // }
  // if(typeof obj == "undefined" || obj == null  || obj == ""){
  //     return true;
  // }else{
  //     return false;
  // }
  //console.log(typeof obj);
  if(typeof obj == 'number'){
    return false;
  }
    if(typeof obj == "undefined" || obj == null || obj == ""){
        return true;
    }else{
        return false;
    }
},

  delObjectKey:function (obj){
	var param={}
	if(obj==null||obj==''||obj==undefined) return param;
	for(var key in obj){
		if(obj[key]!==null&&obj[key]!==''&&obj[key]!==undefined){
			param[key]=obj[key]
		}
	}
	return param
 }

};
export default tools;


// WEBPACK FOOTER //
// ./src/util/tools.js